{
  "it": {
    "overview": {
      "actions": {
        "select_decision": "Seleziona decisione",
        "select_installment": "Seleziona rata",
        "select_point_list": "Seleziona elenco segnalazioni",
        "select_survey": "Seleziona questionario"
      },
      "table": {
        "labels": {
          "category": "Categoria",
          "level": "Livello",
          "project": "Progetto",
          "status": "Stato",
          "unit": "Unità"
        }
      }
    }
  }
}
